const YouTube = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" fill="#FF0033" />
    <path d="M29 20.5L14 12V29L29 20.5Z" fill="white" />
  </svg>
);

export { YouTube };
